import { Dayjs, dayjs } from './dayjs';

export type ReservedSpaceDateRange = {
	id?: string | number;
	startDate: string;
	endDate: string | null;
};

export const isReservedSpaceRangeReserved = (
	reservedSpaces: ReservedSpaceDateRange[] | null | undefined,
	rangeStart: Dayjs,
	rangeEnd: Dayjs | null,
	excludeId?: string | number | null,
): boolean => {
	return (reservedSpaces || []).some(({ id, startDate: reservedStartDate, endDate: reservedEndDate }) => {
		if (excludeId != null && id === excludeId) {
			return false;
		}

		const reservedStart = dayjs.utc(reservedStartDate).startOf('day');
		const reservedEnd = reservedEndDate ? dayjs.utc(reservedEndDate).startOf('day') : null;

		const rangeStartsOnOrBeforeOtherEnd = !reservedEnd || rangeStart.isSameOrBefore(reservedEnd, 'day');
		const otherStartsOnOrBeforeRangeEnd = !rangeEnd || reservedStart.isSameOrBefore(rangeEnd, 'day');

		return rangeStartsOnOrBeforeOtherEnd && otherStartsOnOrBeforeRangeEnd;
	});
};
